<ng-container *ngIf="!isLoading && !hideLayout">
  <app-loader></app-loader>
  <app-navbar></app-navbar>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
  <app-toastr></app-toastr>
</ng-container>

<!-- Show only loader when isLoading is true -->
<div class="container-fluid loader_container" *ngIf="isLoading">
  <div class="dashboard-wrapper">
    <!-- <div class="loader"></div> -->
    <div class="logo-loader">
      <img [src]="helper.adminSettings?.logoImage ? helper.imageUrl + helper.adminSettings?.logoImage : helper.DEFAULT_LOGO"
          alt="Loading..." class="blinking-logo">
  </div>
  </div>
</div>

<!-- Show only the message when navigating to /too-many-requests -->
<router-outlet *ngIf="hideLayout"></router-outlet>